import { OnInit, Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardBodyComponent,
  CardComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { CrudPage, ICrudService, resolveActions } from '@zendra/shared';
import { StandAreaMaintenancePlanningOrchestratorService } from 'orchestrator';
import {
  StandAreaMaintenanceCreateDto,
  StandAreaMaintenanceUpdateDto,
} from '../proxy/geographic/dtos/stand-area-maintenance';
import { StandAreaMaintenanceService } from '../proxy/geographic/controllers';
import { StandAreaMaintenance } from '../stand-area-maintenance/stand-area-maintenance';
import {
  STANDAREAMAINTENANCENOTUPDATED_CONFIG,
  STANDAREAMAINTENANCENOTUPDATED_FIELDS,
} from './stand-area-maintenance-not-updated.config';
import {
  GetStandAreaMaintenanceProjectionListInputDto,
  StandAreaMaintenanceProjectionDto,
  StandAreaMaintenanceProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/stand-area-maintenances/models';

@Component({
  selector: 'app-stand-area-maintenance-not-updated',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
  ],
  providers: [
    ListService,
    StandAreaMaintenanceService,
    ConfirmationService,
  ],
  templateUrl: './stand-area-maintenance-not-updated.html',
})
export class StandAreaMaintenanceNotUpdated extends StandAreaMaintenance implements OnInit {
  private readonly maintenanceCommandService = inject(StandAreaMaintenanceService);
  private readonly pendingUpdatesOrchestratorService = inject(StandAreaMaintenancePlanningOrchestratorService);

  override config = STANDAREAMAINTENANCENOTUPDATED_CONFIG;
  override fields = STANDAREAMAINTENANCENOTUPDATED_FIELDS;

  override service: ICrudService<
    StandAreaMaintenanceProjectionDto,
    StandAreaMaintenanceCreateDto,
    StandAreaMaintenanceUpdateDto,
    StandAreaMaintenanceProjectionExcelDownloadDto
  > = {
    create: input => this.maintenanceCommandService.create(input),
    update: (id, input) => this.maintenanceCommandService.update(id, input),
    deleteByIds: ids => this.maintenanceCommandService.deleteByIds(ids),
    getList: (query: GetStandAreaMaintenanceProjectionListInputDto) =>
      this.pendingUpdatesOrchestratorService.getPendingAreaUpdateFromActiveStandsPaged(query),
    getDownloadToken: () => this.pendingUpdatesOrchestratorService.getDownloadToken(),
    getListAsExcelFile: input =>
      this.pendingUpdatesOrchestratorService.getListAsExcelFile({
        ...input,
        isAreaUpdated: false,
        standIsActive: true,
      }),
  };

  ngOnInit(): void {
    this.actions = resolveActions(
      this.config.actions,
      {
        [this.config.actionIds.updateAreasTrigger]:
          () => this.updateAreas(),
      },
    );
  }

  protected override getEntityName(): string {
    return 'StandAreaMaintenanceNotUpdated';
  }

  private updateAreas(): void {
    this.runBulkAction(ids =>
      this.pendingUpdatesOrchestratorService.updateAreas({ ids })
    );
  }
}
